import {
  Box,
  FormControl,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { Edit, Visibility } from '@material-ui/icons';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import ApplicationResource from '../../../../utils/resources.enum';
import { RowActionsMenu } from './quiz-table';
import { PrintedCorrectionStatusChip } from './status-chip';
import { useStyles } from './styles';
import { getPrintedCorrectionStatus, PRINTED_CORRECTION_STATUS_CONFIG } from './status.util';

const STATUS_FILTER_OPTIONS = [
  { value: 'all', label: 'Todos os status' },
  ...Object.entries(PRINTED_CORRECTION_STATUS_CONFIG).map(([value, { label }]) => ({ value, label })),
];

const PERIOD_FILTER_OPTIONS = [
  { value: 30, label: 'Últimos 30 dias' },
  { value: 90, label: 'Últimos 90 dias' },
  { value: 365, label: 'Último ano' },
  { value: 'all', label: 'Todo o período' },
];

const DEFAULT_PERIOD = 90;

// Assessments without a resolved `createdAt`/`start` are always kept — falling back to
// "hide it" would be worse than showing an item we can't date-filter.
function isWithinPeriod(record, period) {
  if (period === 'all') return true;
  const reference = record.createdAt || record.start;
  if (!reference) return true;
  const daysSince = (Date.now() - new Date(reference).getTime()) / (1000 * 60 * 60 * 24);
  return daysSince <= period;
}

export function PrintedQuizTable({
  records,
  total,
  page,
  perPage,
  onPageChange,
  onPerPageChange,
  correctionByAvailability,
  loading,
}) {
  const classes = useStyles();
  const history = useHistory();
  const [statusFilter, setStatusFilter] = useState('all');
  const [period, setPeriod] = useState(DEFAULT_PERIOD);

  const filteredRecords = records.filter((record) => {
    if (!isWithinPeriod(record, period)) return false;
    if (statusFilter === 'all') return true;
    const correction = correctionByAvailability[record.id];
    if (!correction) return false;
    return getPrintedCorrectionStatus(correction) === statusFilter;
  });

  const goToResults = (id) =>
    history.push(`/${ApplicationResource.QUIZ_ASSESSMENT_AVAILABILITY}/results/${id}`);
  const goToEdit = (id) =>
    history.push(`/${ApplicationResource.QUIZ_ASSESSMENT_AVAILABILITY}/${id}`);

  return (
    <Paper>
      {/*<Box className={classes.tableToolbar}>*/}
      {/*  <Box className={classes.printedFiltersRow}>*/}
      {/*    <Box>*/}
      {/*      <Typography className={classes.filterLabel}>Status</Typography>*/}
      {/*      <FormControl variant="outlined" size="small" className={classes.printedFilterSelect}>*/}
      {/*        <Select value={statusFilter} onChange={(event) => setStatusFilter(event.target.value)}>*/}
      {/*          {STATUS_FILTER_OPTIONS.map(({ value, label }) => (*/}
      {/*            <MenuItem key={value} value={value}>{label}</MenuItem>*/}
      {/*          ))}*/}
      {/*        </Select>*/}
      {/*      </FormControl>*/}
      {/*    </Box>*/}
      {/*    <Box>*/}
      {/*      <Typography className={classes.filterLabel}>Período</Typography>*/}
      {/*      <FormControl variant="outlined" size="small" className={classes.printedFilterSelect}>*/}
      {/*        <Select value={period} onChange={(event) => setPeriod(event.target.value)}>*/}
      {/*          {PERIOD_FILTER_OPTIONS.map(({ value, label }) => (*/}
      {/*            <MenuItem key={value} value={value}>{label}</MenuItem>*/}
      {/*          ))}*/}
      {/*        </Select>*/}
      {/*      </FormControl>*/}
      {/*    </Box>*/}
      {/*  </Box>*/}
      {/*</Box>*/}

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Nome da Avaliação</TableCell>
            <TableCell>Turma</TableCell>
            <TableCell>Qtd. de Questões</TableCell>
            <TableCell>Corrigidas</TableCell>
            <TableCell>Pendentes</TableCell>
            <TableCell>Resultados</TableCell>
            <TableCell>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredRecords.map((record) => {
            const correction = correctionByAvailability[record.id];
            return (
              <TableRow key={record.id}>
                <TableCell>{record.name}</TableCell>
                <TableCell>{record.classes?.map((c) => c.name).join(', ')}</TableCell>
                <TableCell>{record.questionAmount}</TableCell>
                <TableCell>{correction ? correction.correctedCount : '-'}</TableCell>
                <TableCell>{correction ? correction.totalCount - correction.correctedCount : '-'}</TableCell>
                <TableCell>
                  {correction ? <PrintedCorrectionStatusChip {...correction} /> : '-'}
                </TableCell>
                <TableCell>
                  <Box className={classes.rowActions}>
                    {/*<Typography*/}
                    {/*  className={classes.resultsLink}*/}
                    {/*  onClick={() => goToResults(record.id)}*/}
                    {/*>*/}
                    {/*  Ver resultados*/}
                    {/*</Typography>*/}
                    <Tooltip title="Visualizar">
                      <IconButton size="small" onClick={() => goToResults(record.id)}>
                        <Visibility fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Editar">
                      <IconButton size="small" onClick={() => goToEdit(record.id)}>
                        <Edit fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    {/*<RowActionsMenu onEdit={() => goToEdit(record.id)} />*/}
                  </Box>
                </TableCell>
              </TableRow>
            );
          })}
          {!loading && filteredRecords.length === 0 && (
            <TableRow>
              <TableCell colSpan={7} align="center">
                Nenhuma avaliação impressa encontrada
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <TablePagination
        component="div"
        count={total || 0}
        page={page - 1}
        rowsPerPage={perPage}
        onChangePage={(_, newPage) => onPageChange(newPage + 1)}
        onChangeRowsPerPage={(event) => onPerPageChange(parseInt(event.target.value, 10))}
        rowsPerPageOptions={[5, 10, 25]}
        labelRowsPerPage="Linhas por página"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Paper>
  );
}